import { WidgetApi } from "../orchestrator/WidgetApi";
export class WidgetVisibilityApi extends WidgetApi {
    constructor(widgetInstance) {
        super(widgetInstance);
        this._isVisible = false;
        this._eventListeners = new Array();
    }
    async onVisible() {
        if (!this._isVisible) {
            this._isVisible = true;
            await this.fireEvent("visible");
        }
    }
    async onHidden() {
        if (this._isVisible) {
            this._isVisible = false;
            await this.fireEvent("notvisible");
        }
    }
    isVisible() {
        return this._isVisible;
    }
    addEventListener(listener) {
        this._eventListeners.push(listener);
    }
    removeEventListener(listener) {
        let index = this._eventListeners.indexOf(listener);
        if (index > -1) {
            this._eventListeners.splice(index, 1);
        }
    }
    async fireEvent(name) {
        await Promise.all(this._eventListeners.map(async (listener) => {
            if (listener) {
                return listener(name);
            }
        }));
    }
}
